@file:OptIn(ExperimentalUuidApi::class)

package dev.moetz.sslcertificatetool

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid


fun String.toUuidOrNull(): Uuid? {
    return try {
        Uuid.parse(this)
    } catch (_: Throwable) {
        null
    }
}